export const GET_STOCK_LEVELS_REQUEST = 'GET_STOCK_LEVELS_REQUEST';
export const GET_STOCK_LEVELS_SUCCESS = 'GET_STOCK_LEVELS_SUCCESS';
export const GET_STOCK_LEVELS_FAILURE = 'GET_STOCK_LEVELS_FAILURE';
export const ALLOCATE = 'ALLOCATE';
export const ALLOCATE_SALES_ORDERS_AND_ADD_TO_BATCH = 'ALLOCATE_SALES_ORDERS_AND_ADD_TO_BATCH';
export const ALLOCATE_FROM_ORDER_DETAILS_CSW = 'ALLOCATE_FROM_ORDER_DETAILS_CSW';
export const ALLOCATE_FROM_ORDER_DETAILS = 'ALLOCATE_FROM_ORDER_DETAILS';
export const ALLOCATE_FROM_SHIPMENT_DETAILS = 'ALLOCATE_FROM_SHIPMENT_DETAILS';
export const ALLOCATE_FROM_ORDERS_GRID = 'ALLOCATE_FROM_ORDERS_GRID';
export const ALLOCATE_FROM_PRINT_MODAL = 'ALLOCATE_FROM_PRINT_MODAL';
export const ALLOCATE_SUCCESS = 'ALLOCATE_SUCCESS';
export const ALLOCATE_FAILURE = 'ALLOCATE_FAILURE';

export const getStockLevels = (getStockLevelsArgs) => ({
  type: GET_STOCK_LEVELS_REQUEST,
  getStockLevelsArgs,
});

export const getStockLevelsSuccess = (inventoryInfo) => ({
  type: GET_STOCK_LEVELS_SUCCESS,
  inventoryInfo,
});

export const getStockLevelsFailure = (error) => ({
  type: GET_STOCK_LEVELS_FAILURE,
  error,
});

export const allocateFulfillmentPlans = (fulfillmentPlanIds, shipFromId, items, successAction) => ({
  type: ALLOCATE,
  fulfillmentPlanIds,
  shipFromId,
  items,
  successAction,
});

export const allocateFulfillmentPlanFromOrderDetailsCsw = (fulfillmentPlanId, successAction) => ({
  type: ALLOCATE_FROM_ORDER_DETAILS_CSW,
  fulfillmentPlanId,
  successAction,
});

export const allocateFulfillmentPlansFromOrderDetails = (fulfillmentPlanIds, successAction) => ({
  type: ALLOCATE_FROM_ORDER_DETAILS,
  fulfillmentPlanIds,
  successAction,
});

export const allocateFulfillmentPlanFromShipmentDetails = (fulfillmentPlanId, successAction) => ({
  type: ALLOCATE_FROM_SHIPMENT_DETAILS,
  fulfillmentPlanId,
  successAction,
});

export const allocateSelectedFulfillmentPlansFromOrdersGrid = (successAction, fulfillmentPlanIds) => ({
  type: ALLOCATE_FROM_ORDERS_GRID,
  successAction,
  fulfillmentPlanIds,
});

export const allocateFulfillmentPlansFromPrintModal = (fulfillmentPlanIds, onSuccess) => ({
  type: ALLOCATE_FROM_PRINT_MODAL,
  fulfillmentPlanIds,
  onSuccess,
});

/**
 * @param {InventoryAllocationResult[]} inventoryAllocationResults - Results of successful allocation
 * @returns {object} Redux action
 */
export const allocateFulfillmentPlansSuccess = (inventoryAllocationResults) => ({
  type: ALLOCATE_SUCCESS,
  inventoryAllocationResults,
});

/**
 * @param {object} params - Failure parameters
 * @param {InventoryAllocationCheckInfo} params.inventoryAllocationCheckInfo - Information about allocation check failure
 * @param {Array} params.items - Items that failed allocation
 * @param {object} [params.successAction] - Action to dispatch on success retry
 * @param {() => void} [params.onSuccess] - Callback function on success retry
 * @returns {object} Redux action
 */
export const allocateFulfillmentPlansFailure = ({ inventoryAllocationCheckInfo, items, successAction, onSuccess }) => ({
  type: ALLOCATE_FAILURE,
  inventoryAllocationCheckInfo,
  items,
  successAction,
  onSuccess,
});

export const DEALLOCATE = 'DEALLOCATE';
export const deallocateFulfillmentPlans = ({ fulfillmentPlanIds }) => ({
  type: DEALLOCATE,
  fulfillmentPlanIds,
});

export const DEALLOCATE_SILENTLY = 'DEALLOCATE_SILENTLY';
export const deallocateFulfillmentPlansSilently = (fulfillmentPlanIds, successAction) => ({
  type: DEALLOCATE_SILENTLY,
  fulfillmentPlanIds,
  successAction,
});

export const DEALLOCATE_SUCCESS = 'DEALLOCATE_SUCCESS';
export const deallocateSuccess = () => ({
  type: DEALLOCATE_SUCCESS,
});

export const STOCK_LEVEL_REQUEST_PRE_FLIGHT = 'STOCK_LEVEL_REQUEST_PRE_FLIGHT';
export const stockLevelRequestPreFlight = ({ fulfillmentPlans }) => ({
  type: STOCK_LEVEL_REQUEST_PRE_FLIGHT,
  fulfillmentPlans,
});

export const EXPORT_INVENTORY_REQUEST = 'EXPORT_INVENTORY_REQUEST';
export const exportInventory = (data) => ({
  type: EXPORT_INVENTORY_REQUEST,
  data,
});

export const EXPORT_INVENTORY_SUCCESS = 'EXPORT_INVENTORY_SUCCESS';
export const exportInventorySuccess = (data) => ({
  type: EXPORT_INVENTORY_SUCCESS,
  data,
});

export const EXPORT_INVENTORY_ASYNC_SUCCESS = 'EXPORT_INVENTORY_ASYNC_SUCCESS';
export const exportInventoryAsyncSuccess = (messageGuid, data) => ({
  type: EXPORT_INVENTORY_ASYNC_SUCCESS,
  data,
  messageGuid,
});

export const EXPORT_INVENTORY_FAILURE = 'EXPORT_INVENTORY_FAILURE';

export const EXPORT_LOCATIONS_INVENTORY_REQUEST = 'EXPORT_LOCATIONS_INVENTORY_REQUEST';
export const exportLocationsInventory = (data) => ({
  type: EXPORT_LOCATIONS_INVENTORY_REQUEST,
  data,
});

export const EXPORT_LOCATIONS_INVENTORY_ASYNC_SUCCESS = 'EXPORT_LOCATIONS_INVENTORY_ASYNC_SUCCESS';
export const exportLocationsInventoryAsyncSuccess = (messageGuid, data) => ({
  type: EXPORT_LOCATIONS_INVENTORY_ASYNC_SUCCESS,
  data,
  messageGuid,
});

export const EXPORT_TOTES_REQUEST = 'EXPORT_TOTES_REQUEST';
export const exportTotes = (data) => ({
  type: EXPORT_TOTES_REQUEST,
  data,
});

export const EXPORT_TOTES_ASYNC_SUCCESS = 'EXPORT_TOTES_ASYNC_SUCCESS';
export const exportTotesAsyncSuccess = (messageGuid, data) => ({
  type: EXPORT_TOTES_ASYNC_SUCCESS,
  data,
  messageGuid,
});

export const IMPORT_INVENTORY_REQUEST = 'IMPORT_INVENTORY_REQUEST';
export const importInventoryCSV = (data) => ({
  type: IMPORT_INVENTORY_REQUEST,
  data,
});

export const IMPORT_INVENTORY_SUCCESS = 'IMPORT_INVENTORY_SUCCESS';
export const importInventoryCSVSuccess = (data) => ({
  type: IMPORT_INVENTORY_SUCCESS,
  data,
});

export const IMPORT_INVENTORY_FAILURE = 'IMPORT_INVENTORY_FAILURE';

export const GET_IMPORT_SUMMARY = 'GET_IMPORT_SUMMARY';
export const getImportSummary = (jobGuid) => ({
  type: GET_IMPORT_SUMMARY,
  jobGuid,
});

export const OPEN_IMPORT_SUMMARY_MODAL = 'OPEN_IMPORT_SUMMARY_MODAL';
export const openImportSummaryModal = (importSummary) => ({
  type: OPEN_IMPORT_SUMMARY_MODAL,
  importSummary,
});

export const CLOSE_IMPORT_SUMMARY_MODAL = 'CLOSE_IMPORT_SUMMARY_MODAL';
export const closeImportSummaryModal = () => ({
  type: CLOSE_IMPORT_SUMMARY_MODAL,
});

export const BULK_LOAD_INVENTORY_DATA = 'BULK_LOAD_INVENTORY_DATA';
export const reloadInventoryGrid = (pageData) => ({
  type: BULK_LOAD_INVENTORY_DATA,
  pageData,
});
